// "23.10.2026" (kk, ru) or "23/10/2026" (en): day first on every page. Written out by hand, since the
// browsers' Kazakh locale gives "2026-10-23".
const pad = (n) => String(n).padStart(2, "0");

export function formatDate(value, language) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return [pad(date.getDate()), pad(date.getMonth() + 1), date.getFullYear()].join(language === "en" ? "/" : ".");
}

// "23.10.2026, 14:05": the date and its time.
export function formatDateTime(value, language) {
  const day = formatDate(value, language);
  if (!day) return "";
  const date = new Date(value);
  return `${day}, ${pad(date.getHours())}:${pad(date.getMinutes())}`;
}
